import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import * as fromActions from './login.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs';
import { StorageService } from '../../../infrastructure/storage/storage.service';
import { ErrorHandlerService } from '../../../services/error-handler/error-handler.base-service';
import { LoginFacade } from '../../../services/account/login/login.facade';
import { RouterService } from '../../../services/general/router.base-service';
import { IFederatedLoginEnvironmentVariables } from '../../../models';
import * as fromFeedbackActions from '../../general/feedback/feedback.actions';

@Injectable()
export class LoginEffects {
  private actions$ = inject(Actions);
  private loginFacade = inject(LoginFacade);
  private storage = inject(StorageService);
  private routerService = inject(RouterService);
  private errorHandlerService = inject(ErrorHandlerService);

  getLoginData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LoadFederatedLoginData),
      switchMap(({ email, nonce, state, redirectUri, isWeb, loginSource }) => {
        return this.loginFacade
          .getFederatedLoginData(email, nonce, state, redirectUri, loginSource)
          .pipe(
            map(federatedLoginData => {
              const { nonce, state, redirectUrl, realm, clientId, baseUrl, path } =
                federatedLoginData;

              this.storage.setItem(IFederatedLoginEnvironmentVariables.NONCE, nonce);
              this.storage.setItem(IFederatedLoginEnvironmentVariables.STATE, state);
              this.storage.setItem(IFederatedLoginEnvironmentVariables.REALM, realm);
              this.storage.setItem(IFederatedLoginEnvironmentVariables.CLIENT_ID, clientId);
              this.storage.setItem(IFederatedLoginEnvironmentVariables.BASE_URL_AUTH, baseUrl);
              this.storage.setItem(
                IFederatedLoginEnvironmentVariables.AUTHORIZE_ENDPOINT,
                path.replace(/^\/auth\//, '/')
              );
              this.storage.setItem(
                IFederatedLoginEnvironmentVariables.TOKEN_ENDPOINT,
                path.replace(/^\/auth\//, '/').replace(/auth$/, 'token')
              );
              this.storage.setItem(
                IFederatedLoginEnvironmentVariables.COOKIE_DOMAINS,
                'immomio.com'
              );

              if (isWeb) {
                // this.router.navigate(['auth']);
                // window.location.replace(redirectUrl);
                this.routerService.navigateToExternalUrl(redirectUrl);
              }

              return fromActions.LoadFederatedLoginDataSuccess({ federatedLoginData });
            }),
            catchError(error => {
              this.errorHandlerService.handleError('(AUTH ERROR) on login.effects.ts:', error);
              return [fromActions.LoadFederatedLoginDataFailed(error)];
            })
          );
      })
    )
  );
  resendVerifyEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.ResendVerifyEmail),
      switchMap(() => {
        return this.loginFacade.resendVerificationEmail().pipe(
          mergeMap(() => [
            fromActions.ResendVerifyEmailSuccess(),
            fromFeedbackActions.ShowFeedbackInfo({
              message: 'unverified_user.resend_link_info',
            }),
          ]),
          catchError(error => {
            this.errorHandlerService.handleError('(AUTH ERROR) on resendVerifyEmailEmail$:', error);
            return [
              fromActions.ResendVerifyEmailFailed({ error }),
              fromFeedbackActions.ShowFeedbackError({
                message: 'unverified_user.resend_link_error',
              }),
            ];
          })
        );
      })
    )
  );
}
